// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__jAYQt","list":"PatternAutocomplete_list__qA_8d"};